var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('as-modal',{attrs:{"title":"Privacy Policy"},on:{"close":function($event){return _vm.$emit('close')}}},[_c(_vm.component,{tag:"component",staticClass:"privacy-policy"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }